import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_head_3f64e952 from 'nuxt_plugin_head_3f64e952' // Source: ./purchase-quote/head.js (mode: 'all')
import nuxt_plugin_plugin0_1b8ef9dc from 'nuxt_plugin_plugin0_1b8ef9dc' // Source: ./purchase-quote/plugin-0.js (mode: 'client')
import nuxt_plugin_plugin1_1b8f6e3b from 'nuxt_plugin_plugin1_1b8f6e3b' // Source: ./purchase-quote/plugin-1.js (mode: 'all')
import nuxt_plugin_plugin2_1b8fe29a from 'nuxt_plugin_plugin2_1b8fe29a' // Source: ./purchase-quote/plugin-2.js (mode: 'all')
import nuxt_plugin_plugin3_1b9056f9 from 'nuxt_plugin_plugin3_1b9056f9' // Source: ./purchase-quote/plugin-3.js (mode: 'all')
import nuxt_plugin_plugin4_1b90cb58 from 'nuxt_plugin_plugin4_1b90cb58' // Source: ./purchase-quote/plugin-4.js (mode: 'server')
import nuxt_plugin_plugin5_1b913fb7 from 'nuxt_plugin_plugin5_1b913fb7' // Source: ./purchase-quote/plugin-5.js (mode: 'client')
import nuxt_plugin_plugin6_1b91b416 from 'nuxt_plugin_plugin6_1b91b416' // Source: ./purchase-quote/plugin-6.js (mode: 'all')
import nuxt_plugin_plugin7_1b922875 from 'nuxt_plugin_plugin7_1b922875' // Source: ./purchase-quote/plugin-7.js (mode: 'all')
import nuxt_plugin_plugin8_1b929cd4 from 'nuxt_plugin_plugin8_1b929cd4' // Source: ./purchase-quote/plugin-8.js (mode: 'all')
import nuxt_plugin_plugin9_1b931133 from 'nuxt_plugin_plugin9_1b931133' // Source: ./purchase-quote/plugin-9.js (mode: 'all')
import nuxt_plugin_plugin10_565e6003 from 'nuxt_plugin_plugin10_565e6003' // Source: ./purchase-quote/plugin-10.js (mode: 'all')
import nuxt_plugin_plugin11_565ed462 from 'nuxt_plugin_plugin11_565ed462' // Source: ./purchase-quote/plugin-11.js (mode: 'all')
import nuxt_plugin_plugin12_565f48c1 from 'nuxt_plugin_plugin12_565f48c1' // Source: ./purchase-quote/plugin-12.js (mode: 'all')
import nuxt_plugin_plugin13_565fbd20 from 'nuxt_plugin_plugin13_565fbd20' // Source: ./purchase-quote/plugin-13.js (mode: 'all')
import nuxt_plugin_plugin14_5660317f from 'nuxt_plugin_plugin14_5660317f' // Source: ./purchase-quote/plugin-14.js (mode: 'all')
import nuxt_plugin_plugin15_5660a5de from 'nuxt_plugin_plugin15_5660a5de' // Source: ./purchase-quote/plugin-15.js (mode: 'all')
import nuxt_plugin_plugin16_56611a3d from 'nuxt_plugin_plugin16_56611a3d' // Source: ./purchase-quote/plugin-16.js (mode: 'all')
import nuxt_plugin_plugin17_56618e9c from 'nuxt_plugin_plugin17_56618e9c' // Source: ./purchase-quote/plugin-17.js (mode: 'all')
import nuxt_plugin_plugin18_566202fb from 'nuxt_plugin_plugin18_566202fb' // Source: ./purchase-quote/plugin-18.js (mode: 'all')
import nuxt_plugin_plugin19_5662775a from 'nuxt_plugin_plugin19_5662775a' // Source: ./purchase-quote/plugin-19.js (mode: 'all')
import nuxt_plugin_plugin20_566c7784 from 'nuxt_plugin_plugin20_566c7784' // Source: ./purchase-quote/plugin-20.js (mode: 'all')
import nuxt_plugin_plugin21_566cebe3 from 'nuxt_plugin_plugin21_566cebe3' // Source: ./purchase-quote/plugin-21.js (mode: 'all')
import nuxt_plugin_plugin22_566d6042 from 'nuxt_plugin_plugin22_566d6042' // Source: ./purchase-quote/plugin-22.js (mode: 'all')
import nuxt_plugin_plugin23_566dd4a1 from 'nuxt_plugin_plugin23_566dd4a1' // Source: ./purchase-quote/plugin-23.js (mode: 'all')
import nuxt_plugin_plugin24_566e4900 from 'nuxt_plugin_plugin24_566e4900' // Source: ./purchase-quote/plugin-24.js (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_head_3f64e952 === 'function') {
    await nuxt_plugin_head_3f64e952(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin0_1b8ef9dc === 'function') {
    await nuxt_plugin_plugin0_1b8ef9dc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin1_1b8f6e3b === 'function') {
    await nuxt_plugin_plugin1_1b8f6e3b(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin2_1b8fe29a === 'function') {
    await nuxt_plugin_plugin2_1b8fe29a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin3_1b9056f9 === 'function') {
    await nuxt_plugin_plugin3_1b9056f9(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin4_1b90cb58 === 'function') {
    await nuxt_plugin_plugin4_1b90cb58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin5_1b913fb7 === 'function') {
    await nuxt_plugin_plugin5_1b913fb7(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin6_1b91b416 === 'function') {
    await nuxt_plugin_plugin6_1b91b416(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin7_1b922875 === 'function') {
    await nuxt_plugin_plugin7_1b922875(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin8_1b929cd4 === 'function') {
    await nuxt_plugin_plugin8_1b929cd4(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin9_1b931133 === 'function') {
    await nuxt_plugin_plugin9_1b931133(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin10_565e6003 === 'function') {
    await nuxt_plugin_plugin10_565e6003(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin11_565ed462 === 'function') {
    await nuxt_plugin_plugin11_565ed462(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin12_565f48c1 === 'function') {
    await nuxt_plugin_plugin12_565f48c1(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin13_565fbd20 === 'function') {
    await nuxt_plugin_plugin13_565fbd20(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin14_5660317f === 'function') {
    await nuxt_plugin_plugin14_5660317f(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin15_5660a5de === 'function') {
    await nuxt_plugin_plugin15_5660a5de(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin16_56611a3d === 'function') {
    await nuxt_plugin_plugin16_56611a3d(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin17_56618e9c === 'function') {
    await nuxt_plugin_plugin17_56618e9c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin18_566202fb === 'function') {
    await nuxt_plugin_plugin18_566202fb(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin19_5662775a === 'function') {
    await nuxt_plugin_plugin19_5662775a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin20_566c7784 === 'function') {
    await nuxt_plugin_plugin20_566c7784(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin21_566cebe3 === 'function') {
    await nuxt_plugin_plugin21_566cebe3(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin22_566d6042 === 'function') {
    await nuxt_plugin_plugin22_566d6042(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin23_566dd4a1 === 'function') {
    await nuxt_plugin_plugin23_566dd4a1(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin24_566e4900 === 'function') {
    await nuxt_plugin_plugin24_566e4900(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
